// Click capture -> element descriptor (id, tag, classes, text, selector path).

export function startClicks(push) {
  const handler = (e) => {
    const el = e.target;
    if (!el || !(el instanceof Element)) return;
    // Never record interactions with the widget itself (shadow retargeting makes the
    // host div the visible target for everything inside our shadow root).
    if (el.closest && el.closest('[data-ff-root]')) return;
    push({
      type: 'click',
      id: el.id || null,
      tag: el.tagName.toLowerCase(),
      classes: typeof el.className === 'string' && el.className ? el.className : null,
      text: (el.textContent || '').trim().slice(0, 80) || null,
      selector: cssPath(el),
      x: e.clientX,
      y: e.clientY,
    });
  };
  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
}

function cssPath(el, maxDepth = 5) {
  const parts = [];
  let node = el;
  let depth = 0;
  while (node && node.nodeType === 1 && depth < maxDepth) {
    let part = node.tagName.toLowerCase();
    if (node.id) { parts.unshift(`${part}#${node.id}`); break; }
    const cls = typeof node.className === 'string' ? node.className.trim().split(/\s+/).filter(Boolean) : [];
    if (cls.length) part += '.' + cls.slice(0, 2).join('.');
    const parent = node.parentElement;
    if (parent) {
      const sibs = Array.from(parent.children).filter((c) => c.tagName === node.tagName);
      if (sibs.length > 1) part += `:nth-of-type(${sibs.indexOf(node) + 1})`;
    }
    parts.unshift(part);
    node = node.parentElement;
    depth++;
  }
  return parts.join(' > ');
}
